<!-- Title slot -->
<cx-page-slot position="Title" />

<wc-recipe-search [hasControl]="true" />

<!-- Recipe List slot -->
<cx-page-slot position="RecipeList" />
